const isPreview = $('.fb-editor__preview').length > 0;
const $window = $(window);
const $footer = $("footer");
const desktopWidth = 992;
const scrollOffset = 40;
const scrollOffsetMobile = 20;
const navMenuHeightOffset = 60;

/**
 * Create the nav and anchors.
 */
const researchIntegrationCreateNavAndAnchors = function() {
  const $content = $('.research-integration__content');
  const $navMenu = $('.research-integration__nav-menu').addClass('no-titles');
  const $navMenuMobile = $('.research-integration__nav-menu-mobile').addClass('no-titles');
  const $titles = $content.find('h2');

  if ($titles.length <= 1) {
    $('.research-integration__nav').addClass('d-none');
  } else {
    const $body = $('html, body');
    const $container = isPreview ? $('.report-preview-wrapper') : $body;
    const $scrollListener = isPreview ? $('.report-preview-wrapper') : $window;

    if ($('.research-integration__nav').hasClass('d-none')) {
      $('.research-integration__nav').removeClass('d-none')
    }

    $navMenu.removeClass('no-titles').addClass('d-none d-lg-block');
    $navMenuMobile.removeClass('no-titles').addClass('d-flex d-lg-none');

    createAnchorTargets($titles);
    createDesktopNav($titles, $container, $navMenu);
    createMobileNav($titles, $container, $content, $navMenuMobile);
    bindOtherEvents($container, $scrollListener, $content, $navMenu, $navMenuMobile);
  }
};

/**
 * Get the current target based on the scroll of the container.
 */
const findCurrentTargetIndex = function($targetsReverse, $container) {
  let currentTargetIndex = -1;

  // Get the current target.
  $($targetsReverse).each(function(index, target) {
    if (currentTargetIndex === -1) {
      if (isPreview && ($(target).offset().top - scrollOffsetMobile) - navMenuHeightOffset < $container.offset().top) {
        currentTargetIndex = index;
      }
      if (!isPreview && ($(target).offset().top - scrollOffsetMobile) - navMenuHeightOffset < $container.scrollTop()) {
        currentTargetIndex = index;
      }
    }
  });

  return currentTargetIndex;
};

/**
 * Scroll the container to a specified target.
 */
const scrollContainerToTarget = function($target, $container, $isMobileNav) {
  if($isMobileNav === undefined) {
    $isMobileNav = true;
  }
  let navHeightOffset = $isMobileNav ? navMenuHeightOffset : 0;
  let scrollTop = $target.offset().top - $container.offset().top - navHeightOffset;
  if (isPreview) {
    scrollTop += $container.scrollTop();
  }

  if ($('.research-integration__nav-menu-mobile.sticky').length <= 0) {
    // number 30 is the padding that is given to the menu.
    scrollTop = scrollTop - 30;
  }

  $container.animate({ scrollTop: scrollTop }, 500);
};

/**
 * Create the anchor targets to be used in scrolling and identifying which menu item is active.
 */
const createAnchorTargets = function($titles) {
  $titles.each(function(index, el) {
    const $item = $(el);
    $item.before('<a class="research-integration__nav-target" id="research-integration__nav-target-' + index + '" class="">' + $item.html() + '</a>');
  });
};

/**
 * Create the desktop nav.
 */
const createDesktopNav = function($titles, $container, $navMenu) {
  // Create the links.
  let links = '';
  $titles.each(function(index, el) {
    const $item = $(el);
    let itemExtraClass = '';

    if (index == $titles.length - 1) {
      itemExtraClass = 'last-nav-item';
    }

    links += '<li class="research-integration__nav-menu__item ' + itemExtraClass + '"><a class="research-integration__nav-menu__item__link" href="" data-target="research-integration__nav-target-' + index + '">' + $item.html() + '</a></li>';
  });

  $navMenu.prepend(links);

  // Add functionality to links.
  $navMenu.find('.research-integration__nav-menu__item__link:not(.related-article):not(.text-only)').on('click touch', function(event) {
    event.preventDefault();
    const id = $(this).data('target');
    if (id) {
      scrollContainerToTarget($('#' + id), $container, false);
    }
  });
};

/**
 * Create the mobile nav.
 */
const createMobileNav = function($titles, $container, $content, $navMenuMobile) {
  const $dropButton = $navMenuMobile.find('.research-integration__nav-menu-mobile__button');
  const $navMenuMobileOptions = $navMenuMobile.find('.research-integration__nav-menu-mobile__options');

  // Create the dropdown options as links.
  let links = '';

  $titles.each(function(index, el) {
    let $item = $(el);
    links += '<a class="research-integration__nav-menu-mobile__link" href="" data-target="research-integration__nav-target-' + index + '">' + (index + 1) + ' - ' + $item.html() + '</a>';
  });

  $navMenuMobileOptions.prepend(links);

  // Add functionality to links.
  $navMenuMobile.find('.research-integration__nav-menu-mobile__link:not(.related-article):not(.text-only)').on('click touch', function(event) {
    event.preventDefault();

    const link = $(this);
    const id = link.data('target');

    if (id) {
      scrollContainerToTarget($('#' + id), $container);
    }

    // Close the dropdown.
    const dropDownOptions = link.closest('.research-integration__nav-menu-mobile__options')
        .removeClass('open');
    const dropDownButton =  dropDownOptions.siblings('.research-integration__nav-menu-mobile__drop-button')
        .removeClass('open');

    // Update the button text.
    dropDownButton.find('.research-integration__nav-menu-mobile__drop-button__text').html(link.html());
  });

  $navMenuMobile.find('.research-integration__nav-menu-mobile__link.related-article').on('click touch', function(event) {
    // Close the dropdown.
    const dropDownOptions = $(this).closest('.research-integration__nav-menu-mobile__options')
        .removeClass('open');
    dropDownOptions.siblings('.research-integration__nav-menu-mobile__drop-button')
        .removeClass('open');
  });

  // Add functionality to directionals (left and right).
  let $targets = $content.find('.research-integration__nav-target');
  $navMenuMobile.find('.directional-button').on('click touch', function(event) {
    event.preventDefault();
    let $button = $(this);

    if (!$(this).hasClass('disabled')) {
      // Close the dropdown.
      $navMenuMobileOptions.removeClass('open').siblings('.research-integration__nav-menu-mobile__drop-button')
          .removeClass('open');
      // Look for the current target.
      let $targetsReverse = $targets.get().reverse();
      let currentTargetIndex = findCurrentTargetIndex($targetsReverse, $container);

      // Find the actual target of the button press.
      let navTarget = null;
      if ($button.hasClass('research-integration__nav-menu-mobile__left-button')) {
        navTarget = $targetsReverse[currentTargetIndex] !== undefined ? $targetsReverse[currentTargetIndex] : null;
        // If we're currently almost exactly on the current target, use the previous one.
        if (navTarget !== null && ($container.offset().top - $(navTarget).offset().top) < scrollOffsetMobile) {
          navTarget = $targetsReverse[currentTargetIndex + 1] !== undefined ? $targetsReverse[currentTargetIndex + 1] : null;
        }
      } else if ($button.hasClass('research-integration__nav-menu-mobile__right-button')) {
        navTarget = $targetsReverse[currentTargetIndex - 1] !== undefined ? $targetsReverse[currentTargetIndex - 1] : null;

        // If we're not past ANY targets then we must be at the beginning. If so set the first target as next.
        if (currentTargetIndex === -1) {
          navTarget = $targetsReverse[$targetsReverse.length - 1];
        }
      }

      if (navTarget !== null) {
        scrollContainerToTarget($(navTarget), $container);
      }
    }
  });
};

/**
 * Bind events to the navs other than clicking the links or directionals.
 */
const bindOtherEvents = function($container, $scrollListener, $content, $navMenu, $navMenuMobile) {
  let $targetsReverse = $content.find('.research-integration__nav-target').get().reverse();
  $scrollListener.on('scroll', function(event) {
    event.preventDefault();

    if ($container.width() >= desktopWidth) {
      updateActiveNav($container, $navMenu, $targetsReverse);
      moveNav($container, $navMenu);
    } else {
      updateActiveNavMobile($container, $navMenuMobile, $targetsReverse);
      moveNav($container, $navMenuMobile);
    }
  });

  resizeNav($navMenu);
  resizeMobileNav($navMenuMobile, $content);
  $window.resize(function() {
    if ($container.width() >= desktopWidth || !$container.hasClass('apps-view')) {
      resizeNav($navMenu);
      resizeMobileNav($navMenuMobile, $content);
      updateActiveNav($container, $navMenu, $targetsReverse);
      moveNav($container, $navMenu);
    } else {
      resizeMobileNav($navMenuMobile, $content);
      updateActiveNavMobile($container, $navMenuMobile, $targetsReverse);
      moveNav($container, $navMenuMobile);
    }
  });

  $navMenuMobile.find('.research-integration__nav-menu-mobile__drop-button').on('click touch', function(event) {
    event.preventDefault();
    let dropDownButton = $(this);
    let dropDownOptions = dropDownButton.siblings('.research-integration__nav-menu-mobile__options');
    if (dropDownButton.hasClass('open')) {
      dropDownButton.removeClass('open');
      dropDownOptions.removeClass('open');
    } else {
      dropDownButton.addClass('open');
      dropDownOptions.addClass('open');
    }
  });

  if (isPreview) {
    // Preview has the window scrolling as well as the container.
    $window.on('scroll', function(event) {
      if ($container.width() >= desktopWidth) {
        moveNav($container, $navMenu);
      } else {
        moveNav($container, $navMenuMobile);
      }
    });
    // The nav also changes width when the preview buttons are clicked.
    $('.preview-button').on('click touch', function(event) {
      event.preventDefault();
      if ($container.width() >= desktopWidth || $container.hasClass('website-view')) {
        resizeNav($navMenu);
      } else {
        resizeMobileNav($navMenuMobile, $container);
      }
    });
  }
};

/**
 * Update which nav is active.
 */
const updateActiveNav = function($container, $navMenu, $targetsReverse) {
  let activeSelected = false;
  // Add highlighting of links when scrolling into view.
  $($targetsReverse).each(function(index, target) {
    let $navLinks = $navMenu.find('a[data-target="' + $(target).attr('id') + '"]');
    if ($navLinks.length > 0) {
      let $navItem = $navLinks.first().closest('.research-integration__nav-menu__item');
      if (!activeSelected) {
        if ((isPreview && ($(target).offset().top - scrollOffset) < $container.offset().top) ||
          (!isPreview && ($(target).offset().top - scrollOffset) < $container.scrollTop())) {
          $navItem.addClass('active');
          activeSelected = true;

          // Continue with next iteration.
          return true;
        }
      }
      $navItem.removeClass('active');
    }
  });
};

/**
 * Update which nav is active on the mobile nav.
 */
const updateActiveNavMobile = function($container, $navMenuMobile, $targetsReverse) {
  // Update the dropdown when scrolling targets into view.
  const dropDownButton =  $navMenuMobile.find('.research-integration__nav-menu-mobile__drop-button');

  // Get the current target.
  const currentTargetIndex = findCurrentTargetIndex($targetsReverse, $container);
  const currentNavTarget = $targetsReverse[currentTargetIndex] !== undefined ? $targetsReverse[currentTargetIndex] : null;

  let dropdownText = '- Select -';
  if (currentNavTarget !== null) {
    let $navLinks = $navMenuMobile.find('a[data-target="' + $(currentNavTarget).attr('id') + '"]');
    if ($navLinks.length > 0) {
      dropdownText = $navLinks.first().html();
    }
  }

  // Update the button text.
  dropDownButton.find('.research-integration__nav-menu-mobile__drop-button__text').html(dropdownText);

  // if there is only table of contents link then both prev and next buttons should be disabled
  if ($('.research-integration__nav-menu-mobile__link').length <= 1) {
    $navMenuMobile.find('.research-integration__nav-menu-mobile__left-button').addClass('disabled');
    $navMenuMobile.find('.research-integration__nav-menu-mobile__right-button').addClass('disabled');
  } else {
    // Enable or disable the directional buttons depending on position.
    if (currentTargetIndex === null || currentTargetIndex === -1 || currentTargetIndex === $targetsReverse.length - 1) {
      // First or prior to first.
      $navMenuMobile.find('.research-integration__nav-menu-mobile__left-button').addClass('disabled');
      $navMenuMobile.find('.research-integration__nav-menu-mobile__right-button').removeClass('disabled');
    } else if (currentTargetIndex === 0) {
      // Last.
      $navMenuMobile.find('.research-integration__nav-menu-mobile__left-button').removeClass('disabled');
      $navMenuMobile.find('.research-integration__nav-menu-mobile__right-button').addClass('disabled');
    } else {
      // Everything else in between.
      $navMenuMobile.find('.directional-button').removeClass('disabled');
    }
  }
};

const moveNav = function($container, $navMenu) {
  // accommodate different browsers returning different values for scrollTop / offsets for html and body elements
  // mainly addresses issue in safari 12.x
  const bodyScrollTop = Math.max(
    window.pageYOffset,
    document.documentElement.scrollTop,
    document.body.scrollTop
  );
  const containerOffset = $container.offset().top;
  let navTop = 0;

  // Make nav height fixed when touches the footer
  const $nav = $('.research-integration__nav-menu');
  const height = $(window).height();
  const scrollTop = $(window).scrollTop();

  if ($footer.length && height + scrollTop > $footer.position().top) {
    $nav.css('max-height', height - $footer.height() - 30).css('overflow-y', 'scroll')
  } else {
    $nav.css('max-height', '').css('overflow-y', '')
  }
  // End nav adjustment

  if (isPreview) {
    navTop = bodyScrollTop > containerOffset ? 0 : containerOffset - bodyScrollTop;
  }

  if ($navMenu.parent().offset().top < containerOffset || bodyScrollTop > $navMenu.parent().offset().top) {
    $navMenu.parent().css('height', $navMenu.height());
    $navMenu.css({position: 'fixed', top: navTop, 'z-index': '1000'});
    $navMenu.addClass('sticky');
  } else {
    $navMenu.parent().css('height', '');
    $navMenu.css({position: 'relative', top: '', 'z-index': ''});
    $navMenu.removeClass('sticky');
  }
};

/**
 * Adds an explicit width to the desktop nav.
 */
const resizeNav = function($navMenu) {
  $navMenu.css('width', $navMenu.parent().width());
};

/**
 * Adds an explicit width to the mobile nav.
 */
const resizeMobileNav = function($navMenu, $container) {
  $navMenu.css('width', $container.width());
};

export default researchIntegrationCreateNavAndAnchors;
